import React, { Component } from 'react';

import ReactDOM from 'react-dom';

import JSZip from 'jszip';
import PropTypes from 'prop-types';
import './datatables.css';
window.JSZip = JSZip;

const $ = require('jquery');
$.DataTable = require('datatables.net');
$.DataTable.buttons = require('datatables.net-buttons/js/buttons.html5.js');

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: this.props.order || [],
      keepState: this.props.keepState || false,
      selectedRows: new Set(this.props.selectedRows || []),
      selectable: this.props.selectable || false,
      isDropdownOpen: false,
      useCheckboxes: this.props.useCheckboxes || false,
    };
    this.tableRef = React.createRef();
    this.tableInstance = null;
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    this.$el = $(this.el);

    const buttonsConfig = [
      {
        extend: 'excel',
        text: 'Excel completo',
        className: 'btn btn-outline-secondary',
      },
      {
        extend: 'excel',
        text: '&nbsp;&nbsp;Excel pagina&nbsp;&nbsp;&nbsp;',
        className: 'btn btn-outline-secondary',
        exportOptions: {
          modifier: {
            page: 'current',
          },
        },
      },
    ];

    let tableColumns = [...this.props.columns];

    if (this.state.selectable && this.state.useCheckboxes) {
      tableColumns.unshift({
        title:
          '<input type="checkbox" class="select-all-checkbox" title="Selecionar todos da página" autocomplete="off" />',
        data: null,
        orderable: false,
        searchable: false,
        className: 'text-center align-middle',
        render: (data, type, row) => {
          if (type === 'display') {
            const isChecked = this.state.selectedRows.has(
              row.system_maintenance_id
            );
            return `<input type="checkbox" class="row-checkbox" data-id="${row.system_maintenance_id}" ${isChecked ? 'checked' : ''} autocomplete="off" />`;
          }
          return '';
        },
      });
    }

    const tableConfig = {
      dom: "<'row'<'col-sm-6'B><'col-sm-6'f>>rtip",
      buttons: buttonsConfig,
      data: this.props.data,
      columns: tableColumns,
      ordering: true,
      paging: true,
      processing: true,
      serverSide: false,
      order: this.state.order,
      language: {
        emptyTable: 'Nenhum registro encontrado',
        info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
        infoEmpty: 'Mostrando 0 até 0 de 0 registros',
        infoFiltered: '(Filtrados de _MAX_ registros)',
        infoPostFix: '',
        infoThousands: '.',
        lengthMenu: '_MENU_ resultados por página',
        loadingRecords: 'Carregando...',
        processing: 'Processando...',
        zeroRecords: 'Nenhum registro encontrado',
        search: 'Pesquisar',
        paginate: {
          next: 'Próximo',
          previous: 'Anterior',
          first: 'Primeiro',
          last: 'Último',
        },
        aria: {
          sortAscending: ': Ordenar colunas de forma ascendente',
          sortDescending: ': Ordenar colunas de forma descendente',
        },
      },
      columnDefs: [
        ...(typeof this.props.btnColumn === 'number' &&
        typeof this.props.actBtns === 'function'
          ? [
              {
                visible: true,
                orderable: false,
                searchable: false,
                className: 'text-center',
                targets: [
                  this.state.useCheckboxes
                    ? this.props.btnColumn + 1
                    : this.props.btnColumn,
                ],
                createdCell: (td, cellData, rowData) =>
                  ReactDOM.render(this.props.actBtns(rowData), td),
              },
            ]
          : []),
        ...(this.props.edtColumn !== undefined
          ? [
              {
                targets: [
                  this.state.useCheckboxes
                    ? this.props.edtColumn + 1
                    : this.props.edtColumn,
                ],
                createdCell: (td, cellData, rowData) =>
                  ReactDOM.render(
                    <>
                      <span
                        className="text-primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.props.goto(rowData.id)}
                      >
                        {cellData}
                      </span>
                    </>,
                    td
                  ),
              },
            ]
          : []),
      ],
      rowCallback: (row, data) => {
        if (
          this.state.selectable &&
          data &&
          data.system_maintenance_id !== undefined &&
          this.state.selectedRows.has(data.system_maintenance_id)
        ) {
          if (!this.state.useCheckboxes) {
            $(row).addClass('selected');
            $(row).find('td').addClass('selected-cell');
          }
          if (this.state.useCheckboxes) {
            $(row).find('.row-checkbox').prop('checked', true);
          }
        } else {
          $(row).removeClass('selected');
          $(row).find('td').removeClass('selected-cell');
          if (this.state.useCheckboxes) {
            $(row).find('.row-checkbox').prop('checked', false);
          }
        }
        return row;
      },
    };

    this.tableInstance = this.$el.DataTable(tableConfig);

    if (this.state.selectable) {
      this.setupCheckboxListeners();
      setTimeout(() => {
        this.$el.find('.select-all-checkbox').prop('checked', false);
        const dropdownButton = this.renderActionDropdownButton();
        if (dropdownButton) {
          const dtButtonsContainer = $(this.el)
            .closest('.dataTables_wrapper')
            .find('.dt-buttons');
          if (dtButtonsContainer.length) {
            $(dtButtonsContainer).find('.btn:last-child').removeClass('me-2');
            dtButtonsContainer.append(dropdownButton);
            $(dtButtonsContainer).find('.btn').addClass('me-2');
            $(dtButtonsContainer).find('.btn:last-child').removeClass('me-2');
          }
        }
        this.toggleTreatingButtons();
      }, 100);
    }

    document.addEventListener('mousedown', this.handleClickOutside);

    this.tableInstance.on('page.dt', () => {
      if (this.props.selectable) {
        this.updateCheckboxesFromSelectedRows();
        this.toggleTreatingButtons();
      }
    });

    this.tableInstance.on('draw.dt', () => {
      this.toggleTreatingButtons();
    });
  }

  componentWillUnmount() {
    if (this.$el && this.state.selectable) {
      this.$el.off('click', 'tbody tr');
    }
    if (this.tableInstance) {
      try {
        this.tableInstance.buttons().destroy();
      } catch (e) {
        console.warn(
          '[Table.js] Erro (ignorado) ao destruir botões DataTables:',
          e
        );
      }
      this.tableInstance.destroy(true);
      this.tableInstance = null;
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data !== this.props.data) {
      this.reloadTableData(nextProps.data);
      return false;
    }
    if (nextProps.selectable !== this.props.selectable) {
      return true;
    }
    if (
      nextProps.selectable &&
      this.props.onSelectionChange &&
      Array.isArray(nextProps.selectedItems) &&
      nextProps.selectedItems.length === 0 &&
      this.state.selectedRows.size > 0
    ) {
      this.setState({ selectedRows: new Set() }, this.clearSelection);
      return false;
    }
    if (nextState.isDropdownOpen !== this.state.isDropdownOpen) {
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.selectable &&
      this.props.selectedRows !== undefined &&
      Array.isArray(this.props.selectedRows) &&
      this.props.selectedRows.length === 0 &&
      this.state.selectedRows.size > 0
    ) {
      this.setState({ selectedRows: new Set() }, () => {
        this.clearSelection();
        if (this.props.onSelectionChange) {
          this.props.onSelectionChange([]);
        }
        this.atualizarEstadoBotaoAcoes(false);
        if (this.state.useCheckboxes && this.updateCheckboxesFromSelectedRows) {
          this.updateCheckboxesFromSelectedRows();
        }
      });
    }

    if (
      this.props.selectable &&
      this.props.selectedRows !== undefined &&
      Array.isArray(this.props.selectedRows) &&
      JSON.stringify(this.props.selectedRows) !==
        JSON.stringify(prevProps.selectedRows)
    ) {
      this.setState({ selectedRows: new Set(this.props.selectedRows) }, () => {
        this.clearSelection();
        this.tableInstance.rows().every((index) => {
          const rowNode = this.tableInstance.row(index).node();
          const rowData = this.tableInstance.row(index).data();

          if (
            rowData &&
            rowData.system_maintenance_id !== undefined &&
            this.state.selectedRows.has(rowData.system_maintenance_id)
          ) {
            $(rowNode).addClass('selected');
            $(rowNode).find('td').addClass('selected-cell');
            if (this.state.useCheckboxes) {
              $(rowNode).find('.row-checkbox').prop('checked', true);
            }
          } else {
            $(rowNode).removeClass('selected');
            $(rowNode).find('td').removeClass('selected-cell');
            if (this.state.useCheckboxes) {
              $(rowNode).find('.row-checkbox').prop('checked', false);
            }
          }
        });

        this.atualizarEstadoBotaoAcoes(this.state.selectedRows.size >= 2);
        if (this.state.useCheckboxes && this.updateCheckboxesFromSelectedRows) {
          this.updateCheckboxesFromSelectedRows();
        }
      });
    }

    if (
      this.state.useCheckboxes &&
      this.state.selectedRows !== prevState.selectedRows &&
      this.updateCheckboxesFromSelectedRows
    ) {
      this.updateCheckboxesFromSelectedRows();
    }

    if (this.state.selectedRows !== prevState.selectedRows) {
      this.toggleTreatingButtons();
    }
  }

  setupCheckboxListeners() {
    this.$el
      .off('change', '.row-checkbox')
      .on('change', '.row-checkbox', (e) => {
        e.stopPropagation();

        const checkbox = e.target;
        const row = $(checkbox).closest('tr');
        const rowData = this.tableInstance.row(row).data();

        if (rowData && rowData.system_maintenance_id !== undefined) {
          const newSelectedRows = new Set(this.state.selectedRows);

          if (checkbox.checked) {
            newSelectedRows.add(rowData.system_maintenance_id);
          } else {
            newSelectedRows.delete(rowData.system_maintenance_id);
            // Uncheck "select all" when any checkbox is unchecked
            this.$el.find('.select-all-checkbox').prop('checked', false);
          }

          this.setState({ selectedRows: newSelectedRows }, () => {
            if (this.props.onSelectionChange) {
              this.props.onSelectionChange(Array.from(newSelectedRows));
            }
            this.atualizarEstadoBotaoAcoes(newSelectedRows.size >= 2);
            this.updateCheckboxesFromSelectedRows();
            this.toggleTreatingButtons();
          });
        }
      });

    this.$el
      .off('change', '.select-all-checkbox')
      .on('change', '.select-all-checkbox', (e) => {
        const selectAllCheckbox = e.target;
        const isChecked = selectAllCheckbox.checked;

        const currentPageRows = this.tableInstance
          .rows({ page: 'current' })
          .nodes();
        const newSelectedRows = new Set(this.state.selectedRows);

        // Check if there are any unchecked checkboxes on the page
        const hasUncheckedItems =
          $(currentPageRows).find('.row-checkbox:not(:checked)').length > 0;

        // If you are checking and there are unchecked items, or unchecking
        if ((isChecked && hasUncheckedItems) || !isChecked) {
          $(currentPageRows).each((index, rowNode) => {
            const rowData = this.tableInstance.row(rowNode).data();
            if (rowData && rowData.system_maintenance_id !== undefined) {
              if (isChecked) {
                newSelectedRows.add(rowData.system_maintenance_id);
              } else {
                newSelectedRows.delete(rowData.system_maintenance_id);
              }
            }
          });

          // Updates all checkboxes on the page
          this.$el.find('tbody .row-checkbox').prop('checked', isChecked);

          this.setState({ selectedRows: newSelectedRows }, () => {
            if (this.props.onSelectionChange) {
              this.props.onSelectionChange(Array.from(newSelectedRows));
            }

            this.atualizarEstadoBotaoAcoes(newSelectedRows.size >= 2);
            this.toggleTreatingButtons();
          });
        }
      });

    this.updateCheckboxesFromSelectedRows = () => {
      if (!this.state.useCheckboxes || !this.tableInstance) return;

      const currentPageRows = this.tableInstance
        .rows({ page: 'current' })
        .nodes();

      // If the page is empty, uncheck "select all" and return
      if (currentPageRows.length === 0) {
        this.$el.find('.select-all-checkbox').prop('checked', false);
        return;
      }

      let allCurrentPageSelected = true;

      this.tableInstance.rows({ page: 'current' }).every((index) => {
        const rowNode = this.tableInstance.row(index).node();
        const rowData = this.tableInstance.row(index).data();

        if (rowData && rowData.system_maintenance_id !== undefined) {
          const isSelected = this.state.selectedRows.has(
            rowData.system_maintenance_id
          );
          $(rowNode).find('.row-checkbox').prop('checked', isSelected);

          if (!isSelected) {
            allCurrentPageSelected = false;
          }
        }
        return true;
      });

      // Update "select all" only if ALL items on the page are selected
      this.$el
        .find('.select-all-checkbox')
        .prop('checked', allCurrentPageSelected);
    };
  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef &&
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      if (this.state.isDropdownOpen) {
        this.setState({ isDropdownOpen: false }, () => {
          const menu =
            this.dropdownRef.current?.querySelector('.dropdown-menu');
          if (menu) {
            menu.style.display = 'none';
            menu.classList.remove('show');
          }
        });
      }
    }
  };

  toggleDropdown = () => {
    if (this.state.selectedRows.size >= 2) {
      this.setState(
        (prevState) => ({
          isDropdownOpen: !prevState.isDropdownOpen,
        }),
        () => {
          if (this.dropdownRef.current) {
            const menu =
              this.dropdownRef.current.querySelector('.dropdown-menu');
            if (menu) {
              menu.style.display = this.state.isDropdownOpen ? 'block' : 'none';
              menu.classList[this.state.isDropdownOpen ? 'add' : 'remove'](
                'show'
              );
            }
          }
        }
      );
    }
  };

  handleTratarSelecionadas = () => {
    this.setState({ isDropdownOpen: false });

    const selectedIds = Array.from(this.state.selectedRows);

    if (selectedIds.length === 0) {
      alert('Nenhum item selecionado!');
      return;
    }

    if (this.props.onBulkAction) {
      this.props.onBulkAction(selectedIds);
    } else {
      console.warn(
        'Aviso: Nenhum handler onBulkAction definido para tratar as NCs selecionadas'
      );
    }
  };

  renderActionDropdownButton() {
    if (!this.props.selectable) return null;

    const dropdownContainer = document.createElement('div');
    dropdownContainer.className = 'actions-dropdown btn-group';
    dropdownContainer.setAttribute('ref', 'dropdownContainer');
    dropdownContainer.style.position = 'relative';

    const button = document.createElement('button');
    button.className = 'btn btn-outline-secondary dropdown-toggle disabled';
    button.type = 'button';
    button.innerText = 'Ações';
    button.title = 'Selecione pelo menos 2 linhas';
    button.dataset.handlerAttached = 'true';

    const self = this;
    button.addEventListener('click', function (e) {
      if (!button.classList.contains('disabled')) {
        self.toggleDropdown();
      }
    });

    dropdownContainer.appendChild(button);

    const dropdownMenu = document.createElement('div');
    dropdownMenu.className = 'dropdown-menu';
    dropdownMenu.style.display = 'none';
    dropdownMenu.style.position = 'absolute';
    dropdownMenu.style.top = '100%';
    dropdownMenu.style.left = '0';
    dropdownMenu.style.zIndex = '1000';
    dropdownMenu.style.minWidth = '10rem';

    const menuItem = document.createElement('button');
    menuItem.className = 'dropdown-item';
    menuItem.type = 'button';
    menuItem.innerText = 'Tratar selecionadas';
    menuItem.addEventListener('click', () => this.handleTratarSelecionadas());

    dropdownMenu.appendChild(menuItem);
    dropdownContainer.appendChild(dropdownMenu);

    this.dropdownRef.current = dropdownContainer;

    return dropdownContainer;
  }

  atualizarEstadoBotaoAcoes(habilitado) {
    try {
      const botaoAcoes = this.dropdownRef.current?.querySelector('button');
      if (!botaoAcoes) return;

      if (habilitado) {
        botaoAcoes.classList.remove('disabled');
        botaoAcoes.style.pointerEvents = 'auto';
        botaoAcoes.style.opacity = '1';
        botaoAcoes.title = 'Clique para ações em massa';
      } else {
        botaoAcoes.classList.add('disabled');
        botaoAcoes.style.pointerEvents = 'none';
        botaoAcoes.style.opacity = '0.65';
        botaoAcoes.title = 'Selecione pelo menos 2 linhas';
      }

      if (this.dropdownRef.current) {
        const menu = this.dropdownRef.current.querySelector('.dropdown-menu');
        if (menu) {
          menu.style.display = this.state.isDropdownOpen ? 'block' : 'none';
          menu.classList[this.state.isDropdownOpen ? 'add' : 'remove']('show');
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar estado do botão Ações:', error);
    }
  }

  toggleTreatingButtons() {
    const hasSelectedItems = this.state.selectedRows.size > 0;
    const $treating = $(document).find('.treating');

    if (hasSelectedItems) {
      $treating.addClass('disabled');
      $treating.on('click.disabled', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });
    } else {
      $treating.removeClass('disabled');
      $treating.off('click.disabled');
    }
  }

  clearSelection() {
    if (this.tableInstance) {
      this.tableInstance
        .rows()
        .nodes()
        .forEach((node) => {
          $(node).removeClass('selected');
          $(node).find('td').removeClass('selected-cell');
          if (this.state.useCheckboxes) {
            $(node).find('.row-checkbox').prop('checked', false);
          }
        });
      this.$el.find('.select-all-checkbox').prop('checked', false);
    }
  }

  getSelectedRows() {
    return Array.from(this.state.selectedRows);
  }

  resetSelections = () => {
    if (this.state.selectable) {
      this.setState({ selectedRows: new Set() }, () => {
        this.clearSelection();
        this.atualizarEstadoBotaoAcoes(false);
        this.toggleTreatingButtons();
        if (this.props.onSelectionChange) {
          this.props.onSelectionChange([]);
        }
      });
    }
  };

  reloadTableData = (data) => {
    if (!this.tableInstance) return;

    const pageInfo = this.tableInstance.page.info();
    const currentPage = pageInfo.page;
    const currentSearch = this.tableInstance.search();
    const currentOrder = this.tableInstance.order();
    const currentSelections = new Set(this.state.selectedRows);

    this.tableInstance.clear();
    this.tableInstance.rows.add(data);

    if (this.state.keepState) {
      this.tableInstance.search(currentSearch);
      this.tableInstance.order(currentOrder);
      this.tableInstance.draw('full-hold');

      if (currentPage < this.tableInstance.page.info().pages) {
        this.tableInstance.page(currentPage).draw('page');
      } else {
        this.tableInstance.page('last').draw('page');
      }
    } else {
      this.tableInstance.draw();
    }

    if (this.state.useCheckboxes) {
      this.$el.find('.select-all-checkbox').prop('checked', false);
    }

    if (this.state.selectable) {
      try {
        const existingIds = new Set();
        const updatedSelections = new Set();

        this.tableInstance.rows().every((index) => {
          const rowData = this.tableInstance.row(index).data();
          if (rowData && rowData.system_maintenance_id !== undefined) {
            existingIds.add(rowData.system_maintenance_id);
            if (currentSelections.has(rowData.system_maintenance_id)) {
              updatedSelections.add(rowData.system_maintenance_id);
            }
          }
          return true;
        });

        if (updatedSelections.size !== currentSelections.size) {
          this.setState({ selectedRows: updatedSelections }, () => {
            if (this.props.onSelectionChange) {
              this.props.onSelectionChange(Array.from(updatedSelections));
            }
          });
        }

        this.tableInstance.rows().every((index) => {
          const rowNode = this.tableInstance.row(index).node();
          const rowData = this.tableInstance.row(index).data();

          if (
            rowData &&
            rowData.system_maintenance_id !== undefined &&
            updatedSelections.has(rowData.system_maintenance_id)
          ) {
            $(rowNode).addClass('selected');
            $(rowNode).find('td').addClass('selected-cell');
            if (this.state.useCheckboxes) {
              $(rowNode).find('.row-checkbox').prop('checked', true);
            }
          } else {
            $(rowNode).removeClass('selected');
            $(rowNode).find('td').removeClass('selected-cell');
            if (this.state.useCheckboxes) {
              $(rowNode).find('.row-checkbox').prop('checked', false);
            }
          }
          return true;
        });

        if (this.state.useCheckboxes && this.updateCheckboxesFromSelectedRows) {
          this.updateCheckboxesFromSelectedRows();
        }

        this.atualizarEstadoBotaoAcoes(updatedSelections.size >= 2);
      } catch (error) {
        console.error(
          '[Table.js] Erro ao atualizar seleções após recarregar dados:',
          error
        );
      }
    }
  };

  render() {
    return (
      <div className="table-container">
        <table
          className="table table-borderless display"
          id={this.props.id}
          width="100%"
          cellSpacing="0"
          ref={(el) => (this.el = el)}
        />
      </div>
    );
  }
}

Table.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  actBtns: PropTypes.func,
  order: PropTypes.array,
  keepState: PropTypes.bool,
  selectable: PropTypes.bool,
  onSelectionChange: PropTypes.func,
  selectedRows: PropTypes.array,
  edtColumn: PropTypes.number,
  goto: PropTypes.func,
  onBulkAction: PropTypes.func,
  useCheckboxes: PropTypes.bool,
};

Table.defaultProps = {
  order: [],
  keepState: false,
  selectable: false,
};

export default Table;
